<form class="filter-date-modal-molecule-root">
  <button id="close-filter-date-icon" (click)="onCloseClick()" mat-icon-button class="close-button">
    <mat-icon>cancel</mat-icon>
  </button>

  <app-header>{{ labels.filterByDate }}</app-header>
  <div mat-dialog-content>
    <app-label isGray class="label">{{ labels.date }}</app-label>
    <div class="date-filters">
      <app-chip id="last-3-months-filter"
                small
                (selectFilterClick)="last3Months()"
                [active]="!!activeFilter.last3Months"
                gray>
        {{ labels.last3Months }}
      </app-chip>
      <app-chip id="last-6-months-filter"
                small
                (selectFilterClick)="last6Months()"
                [active]="!!activeFilter.last6Months"
                gray>
        {{ labels.last6Months }}
      </app-chip>
      <app-chip id="last-year-filter"
                small
                (selectFilterClick)="lastYear()"
                [active]="!!activeFilter.lastYear"
                gray>
        {{ labels.lastYear }}
      </app-chip>
    </div>
    <app-label isGray class="label">{{ labels.dateRange }}</app-label>
    <div class="date-picker-group">
      <div>
        <app-input id="starting-date-input-filter"
                   [label]="labels.startingDate + ':'"
                   [control]="form.controls['startingDate']"
                   [datepicker]="startingDate">
        </app-input>
        <mat-datepicker #startingDate></mat-datepicker>
      </div>
      <div>
        <app-input id="ending-date-input-filter"
                   [label]="labels.endingDate + ':'"
                   [control]="form.controls['endingDate']"
                   [datepicker]="endingDate">
        </app-input>
        <mat-datepicker #endingDate></mat-datepicker>
      </div>
    </div>
    </div>
  <div mat-dialog-actions>
    <app-primary-button class="success-button"
                        id="get-date-filter-btn"
                        mat-button
                        type="submit"
                        [abstractControl]="form"
                        (clickAction)="getDateFilter()">
      {{ labels.filterByDate }}
    </app-primary-button>
    <app-primary-button id="clear-filters-btn"
                        mat-button
                        (clickAction)="onClearFilters()">
      {{ labels.clearFilter }}
    </app-primary-button>
  </div>
</form>
